import React from 'react';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import ListTable from 'components/table/ListTable';
import { useUIUtils } from 'hooks/useUIUtils';
 
const List = ({ match, saludo, subtitulo }) => {
    const { changeGlobalTitle } = useUIUtils()
    const { path } = match;
    const columns = [
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'metodo', headerName: 'Metodo', flex: 1},
        { field: 'mensaje', headerName: 'Mensaje', flex: 1,editable: true },
        { field: 'Codigo', headerName: 'codigo', flex: 1},
        { field: 'fecha_Envio', headerName: 'Fecha' , flex: 1}
    ];

    React.useEffect(() => {
        changeGlobalTitle('Notificaciones', 'Listado de notificaciones de los mensajes de su e-Commerce.')
        validarExisteSucursalPrincipal();
    },[changeGlobalTitle]);

    return (
        <>
            <div className='container-fluid'>


                <div className='col-md-12'>

                <ListTable
                    
                    columns={columns}
                    path = {path}
                    url={`LogNotificacion/GetList?sucursal_Id=${getDataSession('sucursal')}`}
                  />
                    {/*<Table
                        columns={['Metodo', 'Mensaje', 'Codigo', 'Fecha']}
                        rows={[
                            ['text', 'metodo'],
                            ['text', 'mensaje'],
                            ['text', 'codigo'],
                            ['date', 'fecha_Envio']
                        ]}
                        path={path}
                        url={`/LogNotificacion/List?sucursal_Id=${getDataSession('sucursal')}`}
                    ></Table>*/}
                    {/*
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Metodo</th>
                                    <th>Mensaje</th>
                                    <th>Codigo</th>
                                    <th>Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(data?.length > 0) ?  data?.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.metodo}</td>
                                            <td>{item.mensaje}</td>
                                            <td>{item.codigo}</td>
                                            <td>{item.fecha_Envio}</td>
                                        </tr>
                                    );
                                }) : <tr>
                                    <td className='text-center' colSpan={11}>Sin Notificaciones</td>
                                    </tr>}
                            </tbody>
                            </table>*/}
                </div>
            </div>
        </>
    );
};

export { List };
